import {
  Component,
  ChangeDetectorRef,
} from '@angular/core'
import { ActivatedRoute, Router } from '@angular/router'
import { MagliveApiClient } from 'src/lib/api-client/maglive-api-client'
import {
  GiftPointHistory,
  GiftPointHistoryGetRequest,
} from 'src/lib/entity/manage-point'
import * as encoding from 'encoding-japanese'
import { saveAs } from 'file-saver'
import { ToastrService } from 'ngx-toastr'

@Component({
  selector: 'maglive-admin-sales-history-index',
  templateUrl: './sales-history-index.component.html',
  styleUrls: [
    '../../../../pages/admin/startbootstrap-sb-admin-gh-pages/src/scss/styles.scss',
    './sales-history-index.component.scss',
  ],
})
export class AdminSalesHistoryIndexComponent {
  // 検索パラメータ
  search = {
    id: null,
    magazineId: null,
    receiverId: null,
    senderId: null,
    createdAtStart: null,
    createdAtEnd: null,
  }

  giftPointHistories: GiftPointHistory[] = []

  /**
   * 無限スクロール対象要素の親クラス名
   * https://www.npmjs.com/package/ngx-infinite-scroll fromRoot
   */
  infiniteScrollParentSelector: string = '.admin-sales-history-scroll-wrap'

  // 無限スクロールでデータを取りきったかどうかのフラグ
  private allRead: Boolean = false
  // データ取得中かどうかのフラグ
  isLoading: Boolean = false

  invalidCsvDl: Boolean
  csvDateValidationError: Boolean = false
  dateRequiredError: Boolean = false

  // 無限スクロールの起点となるドキュメントID
  private lastDocumentId: string | null = null

  constructor(
    public changeDetectorRef: ChangeDetectorRef,
    private toastr: ToastrService,
    private router: Router,
    private route: ActivatedRoute
  ) {}

  ngOnInit(): void {
    this.search.id = this.route.snapshot.queryParamMap.get('id') || null
    this.search.magazineId =
      this.route.snapshot.queryParamMap.get('magazineId') || null
    this.search.receiverId =
      this.route.snapshot.queryParamMap.get('receiverId') || null
    this.search.senderId =
      this.route.snapshot.queryParamMap.get('senderId') || null
    this.search.createdAtStart =
      this.route.snapshot.queryParamMap.get('createdAtStart') || null
    this.search.createdAtEnd =
      this.route.snapshot.queryParamMap.get('createdAtEnd') || null
    const request: GiftPointHistoryGetRequest = {
      ...this.search,
      createdAtStart: this.search.createdAtStart
        ? Date.parse(this.search.createdAtStart) / 1000
        : null,
      createdAtEnd: this.search.createdAtEnd
        ? Date.parse(this.search.createdAtEnd) / 1000
        : null,
      lastDocumentId: null,
    }
    this.isLoading = true
    this.getGiftPointHistories(request)
  }

  /**
   * 検索条件に基づいたギフト収益履歴一覧を取得する
   */
  execSearch(): void {
    this.lastDocumentId = null
    const request: GiftPointHistoryGetRequest = {
      ...this.search,
      createdAtStart: this.search.createdAtStart
        ? Date.parse(this.search.createdAtStart) / 1000
        : null,
      createdAtEnd: this.search.createdAtEnd
        ? Date.parse(this.search.createdAtEnd) / 1000
        : null,
      lastDocumentId: null,
    }
    this.isLoading = true
    this.allRead = false
    this.getGiftPointHistories(request)
    // 強制的に再描画させる
    this.changeDetectorRef.detectChanges()
    this.router.navigate([], {
      relativeTo: this.route,
      queryParams: {
        ...this.search,
      },
    })
  }

  /**
   * スクロールイベントをトリガーする
   */
  onScroll() {
    if (this.allRead || this.isLoading) return
    const request: GiftPointHistoryGetRequest = {
      ...this.search,
      createdAtStart: this.search.createdAtStart
        ? Date.parse(this.search.createdAtStart) / 1000
        : null,
      createdAtEnd: this.search.createdAtEnd
        ? Date.parse(this.search.createdAtEnd) / 1000
        : null,
      lastDocumentId: this.lastDocumentId,
    }
    this.isLoading = true
    this.getGiftPointHistoriesByScroll(request)
    // 強制的に再描画させる
    this.changeDetectorRef.detectChanges()
  }

  /**
   * ギフト収益履歴を取得する
   */
  private getGiftPointHistories(request: GiftPointHistoryGetRequest): void {
    MagliveApiClient.getGiftPointHistoriesForManage(request).subscribe(
      (response) => {
        if (response !== 'NOT_FOUND') {
          this.giftPointHistories = response.items
          this.lastDocumentId = response.lastDocumentId
        } else {
          this.giftPointHistories = []
        }
        this.isLoading = false
      }
    )
  }

  /**
   * スクロール時にギフト収益履歴を取得する
   */
  private getGiftPointHistoriesByScroll(
    request: GiftPointHistoryGetRequest
  ): void {
    MagliveApiClient.getGiftPointHistoriesForManage(request).subscribe(
      (response) => {
        if (response !== 'NOT_FOUND' && response.items.length > 0) {
          if (this.giftPointHistories.length !== 0) {
            this.giftPointHistories = this.giftPointHistories.concat(
              response.items
            )
          } else {
            this.giftPointHistories = response.items
          }
          this.lastDocumentId = response.lastDocumentId
        } else {
          this.allRead = true
        }
        this.isLoading = false
      }
    )
  }

  exportCsvSalesHistory() {
    if (!this.search.createdAtEnd || !this.search.createdAtStart) {
      this.dateRequiredError = true
      return
    } else this.dateRequiredError = false
    this.lastDocumentId = null
    //日付の差が 1 か月以上あるかどうかを検証
    var months
    const start = new Date(this.search.createdAtStart)
    const end = new Date(this.search.createdAtEnd)
    months = (start.getFullYear() - end.getFullYear()) * 12
    months -= start.getMonth()
    months += end.getMonth()
    if (start.getDate() > end.getDate()) months--
    months <= 0
      ? (this.csvDateValidationError = false)
      : (this.csvDateValidationError = true)

    const request: GiftPointHistoryGetRequest = {
      ...this.search,
      createdAtStart: this.search.createdAtStart
        ? Date.parse(this.search.createdAtStart) / 1000
        : null,
      createdAtEnd: this.search.createdAtEnd
        ? Date.parse(this.search.createdAtEnd) / 1000
        : null,
      lastDocumentId: null,
    }
    if (!this.csvDateValidationError) this.getCsvData(request)
  }

  getCsvData(request: GiftPointHistoryGetRequest) {
    this.invalidCsvDl = true
    MagliveApiClient.exportCsvSalesHistory(request).subscribe(
      (value) => {
        if (value === 'NOT_FOUND') {
          this.invalidCsvDl = false
          this.toastr.error('エラーが発生しました。')
          return
        }
        if (!value.fileData.length) {
          this.invalidCsvDl = false
          this.toastr.error('ギフト収益履歴データが存在していません。')
          return
        }

        const fileName = value.fileName
        const fileData = value.fileData

        const unicodeList = []
        for (let i = 0; i < fileData.length; i++) {
          unicodeList.push(fileData.charCodeAt(i))
        }

        const shiftJisCodeList = encoding.convert(
          unicodeList,
          'SJIS',
          'UNICODE'
        )
        const unit8Array = new Uint8Array(shiftJisCodeList)

        const blob = new Blob([unit8Array], { type: 'text/csv' })

        saveAs(blob, fileName)
        this.invalidCsvDl = false
      },
      (error) => {
        this.invalidCsvDl = false
        console.log(error)
      }
    )
  }
}
